import { AxiosRequestConfig } from "axios";
import {
  ALFRESCO_USER,
  ALFRESCO_SECRET,
  VUE_APP_SIT_API_URL,
  BASE_PATH_APP
} from "@/commons/config";

import TransportadoraAuthService from "@/services/transportadora.auth.service";
import GessanAuthService from "@/services/gessan/auth.service";
import { router } from "@/router";

export const handleRequest = (config: any) => {
  const { token = null } = JSON.parse(localStorage.getItem(`${BASE_PATH_APP}-auth`)) || {};
  const { path = "" } = router.currentRoute || {};
  const isTransportadoraContext = path.startsWith("/transportes");
  const isGessanContext = path.startsWith("/saneamento");

  let baseToken: string | null;
  if (isTransportadoraContext) {
    baseToken = TransportadoraAuthService.token 
  } else if (isGessanContext) {
    baseToken = GessanAuthService.token;
  } else {
    baseToken = token || TransportadoraAuthService.token || GessanAuthService.token;
  }
  const authHeader = baseToken ? `Bearer ${baseToken}` : "";
  if (config.url.includes("https://documentos.arce.ce.gov.br/alfresco/api/")) {
    (config.headers = {
      ...config.headers,
      Accept: "application/json",
      "Content-Type": "application/json"
    }),
      (config.auth = {
        username: ALFRESCO_USER,
        password: ALFRESCO_SECRET
      });
  } else if (config.url.includes(VUE_APP_SIT_API_URL)) {
    config.headers = {
      ...config.headers
    };
  } else {
    config.headers = {
      ...config.headers,
      Authorization: authHeader,
      Accept: "application/json",
      "Content-Type": "application/json"
    };
  }

  return config;
};

export const handleErrorRequest = (error: any) => Promise.reject(error);
